// Global Instructions Rule Applied!
// Grid row shape returned by view__investor_statement_runs (spec A3.14
// stage 5): one statement run - a quarter's statements for one fund or many.
// The backend twin is investor_statement_run_record.py; both are strict, so a
// key the read starts to emit is added to both first.
import { z } from 'zod'
import { validateWithZodSchema } from '../../core/utils/utilities.ts'

export const InvestorStatementRunRecordSchema = z
  .object({
    investor_statement_runs__id: z.string(),
    investor_statement_runs__name: z.string(),
    investor_statement_runs__period_end: z.string(),
    investor_statement_runs__period_end_fmt: z.string(),
    // '2026 Q2'
    prog__period_label: z.string(),
    investor_statement_runs__statement_date: z.string(),
    investor_statement_runs__statement_date_fmt: z.string(),
    investor_statement_runs__notes: z.string().nullish(),
    investor_statement_runs__date_created: z.string().nullish(),
    investor_statement_runs__date_created_fmt: z.string().nullish(),
    // the funds and consolidated funds of the run, by name; '-' when none
    prog__fund_names: z.string(),
    prog__fund_count: z.number(),
    // current statements that are stored
    prog__statement_count: z.number(),
    prog__file_size_bytes: z.number(),
    prog__file_size_fmt: z.string()
  })
  .strict()

export type InvestorStatementRunRecord = z.infer<typeof InvestorStatementRunRecordSchema>

export const InvestorStatementRunRecordFields = Object.fromEntries(
  Object.keys(InvestorStatementRunRecordSchema.shape).map((k) => [k, k])
) as Record<keyof typeof InvestorStatementRunRecordSchema.shape, string>

export function validateInvestorStatementRunRecord(data: unknown, isArray: true): InvestorStatementRunRecord[]
export function validateInvestorStatementRunRecord(data: unknown, isArray?: false): InvestorStatementRunRecord
export function validateInvestorStatementRunRecord(
  data: unknown,
  isArray?: boolean
): InvestorStatementRunRecord | InvestorStatementRunRecord[]
export function validateInvestorStatementRunRecord(
  data: unknown,
  isArray = false
): InvestorStatementRunRecord | InvestorStatementRunRecord[] {
  try {
    return validateWithZodSchema(InvestorStatementRunRecordSchema, data, 'investor statement run record', { isArray })
  } catch (error) {
    throw new Error(`Investor statement run validation failed: ${error}`)
  }
}
